<template>
    <div class="materi-form-component">
        <div class="materi-body">
            <b-form data-vv-scope="materi-form">
                <!-- <b-form-group
                    label="Terbitkan ?"
                    label-for="published"
                    label-cols-sm="3"
                    label-align-sm="left"
                >
                    <b-form-radio-group
                        id="materi-publish"
                        name="materi_publish"
                        v-model="materi_form.is_publish"
                        :options="options"
                        class=""
                        value-field="item"
                        text-field="name"
                        disabled-field="notEnabled"
                    ></b-form-radio-group>
                    <span :class="{ 'error-validation': errors.first('materi-form.materi_publish') }">{{ errors.first('materi-form.materi_publish') }}</span>
                </b-form-group> -->
                <b-form-group
                    label="Judul Materi"
                    label-for="title"
                    label-cols-sm="3"
                    label-align-sm="left"
                >
                    <b-form-input
                        id="title-materi"
                        name="title_materi"
                        data-vv-as="Judul materi"
                        v-model="materi_form.name"
                        type="text"
                        placeholder="Judul Materi"
                        v-validate="'required'"
                        autocomplete="off"
                    ></b-form-input>
                    <span :class="{ 'error-validation': errors.first('materi-form.title_materi') }">{{ errors.first('materi-form.title_materi') }}</span>
                </b-form-group>
                <b-form-group
                    label="Sumber Materi"
                    label-for="Sumber Materi"
                    label-cols-sm="3"
                    label-align-sm="left">
                    <b-form-radio-group
                        id="tes"
                        name="tes"
                        v-model="materi_form.is_file"
                        :options="option_links"
                        class="mb-3"
                        value-field="item"
                        text-field="name"
                    ></b-form-radio-group>
                    <span :class="{ 'error-validation': errors.first('petunjuk-form.is_file') }">{{ errors.first('petunjuk-form.is_file') }}</span>
                </b-form-group>
                <b-form-group
                    v-if="materi_form.is_file==1"
                    label="Pilih Sumber"
                    label-for="Pilih Sumber"
                    label-cols-sm="3"
                    label-align-sm="left">
                    <b-form-radio-group
                        id="fileType"
                        name="fileType"
                        v-model="materi_form.file_type"
                        :options="option_types"
                        class="mb-3"
                        value-field="item"
                        text-field="name"
                        v-validate="'required'"
                    ></b-form-radio-group>
                    <span :class="{ 'error-validation': errors.first('petunjuk-form.file_type') }">{{ errors.first('petunjuk-form.file_type') }}</span>
                </b-form-group>
                <b-form-group
                    v-if="materi_form.is_file==1"
                    label="Input Link"
                    label-for="Input Link"
                    label-cols-sm="3"
                    label-align-sm="left"
                >
                    <b-form-input v-model="materi_form.file_path" v-validate="'required'"></b-form-input>
                    <span :class="{ 'error-validation': errors.first('petunjuk-form.file_path') }">{{ errors.first('petunjuk-form.file_path') }}</span>
                </b-form-group>
                <b-form-group
                    v-if="materi_form.is_file==0"
                    label="Isi Materi"
                    label-for="desc"
                    label-cols-sm="3"
                    label-align-sm="left"
                >
                    <wysiwyg
                        id="desc-materi"
                        name="description_materi"
                        data-vv-as="Isi materi"
                        v-model="materi_form.description"
                        type="text"
                        v-validate="'required'"
                        autocomplete="off"
                    />
                    <span :class="{ 'error-validation': errors.first('materi-form.description_materi') }">{{ errors.first('materi-form.description_materi') }}</span>
                </b-form-group>
            </b-form>
        </div>
        <hr>
        <div class="new-class-footer d-flex justify-content-end">
            <square-loader :loading="showLoader" :color="'#ca062a'" :size="'30px'"></square-loader>
            <b-button v-if="!showLoader" variant="outline-danger" size="md" style="width: 25%;" @click="hideMateriFormModal">BATAL</b-button>
            <b-button v-if="!showLoader" variant="primary" size="md" style="width: 25%;" @click.prevent="saveMateri">SIMPAN</b-button>
        </div>
    </div>
</template>
<script>
    import SquareLoader from 'vue-spinner/src/SquareLoader.vue'
    import { EventBus } from '@/eventBus.js'
    export default {
        props: {
            modulId: {
                type: String,
                default: null
            },
            materiId: {
                type: String,
                default: null
            },
            materiDetail: {
                type: Object,
                default () {
                    return {}
                }
            }
        },
        components: {
            SquareLoader
        },
        data() {
            return {
                showLoader: false,
                materi_form: {
                    learning_activity_id: this.modulId,
                    name: this.materiId ? this.materiDetail.name : null,
                    description: this.materiId ? this.materiDetail.description : null,
                    is_publish: this.materiId ? this.materiDetail.is_publish : 1,
                    is_file: this.materiId ? this.materiDetail.is_file : 0,
                    file_type: this.materiId ? this.materiDetail.file_type : 'text',
                    file_path: this.materiId ? this.materiDetail.file_path : '-'
                },
                options: [
                    { item: '1', name: 'Ya' },
                    { item: '0', name: 'Tidak' },
                ],
                option_links: [
                    { item: '1', name: 'Link' },
                    { item: '0', name: 'Text' },
                ],
                option_types: [
                    { item: 'pdf', name: 'Google Drive' },
                    { item: 'video', name: 'Youtube' },
                ]
            };
        },
        methods: {
            resetMateriForm() {
                this.materi_form.learning_activity_id = this.modulId,
                this.materi_form.name = this.materiId ? this.materiDetail.name : null,
                this.materi_form.description = this.materiId ? this.materiDetail.description : null,
                this.materi_form.is_publish = this.materiId ? this.materiDetail.is_publish : 0,
                this.$validator.reset()
            },
            hideMateriFormModal() {
                EventBus.$emit('hideMateriFormModal', true)
                this.resetMateriForm()
            },
            async saveMateri() {
                let scope = 'materi-form'
                this.$validator.validateAll(scope).then(valid => {
                    if (valid) {
                        if (this.materiId) {
                            this.materi_form.id = this.materiId
                            this.updateMateri(scope)
                        } else {
                            this.addMateri(scope)
                        }
                    }
                });
            },
            async addMateri(scope) {
                this.showLoader = true
                if(this.materi_form.is_file==1){
                    this.materi_form.description = '-'
                }else{
                    this.materi_form.file_type = 'text'
                    this.materi_form.file_path = '-'
                }
                let form = this.materi_form
                this.$store.dispatch('addMateri', form)
                    .then((res) => {
                        this.showLoader = false
                        let modulId = this.modulId
                        this.$store.dispatch('getModulDetail', { modulId })
                        this.hideMateriFormModal()
                        this.$swal.fire('Success', res.message, 'success')
                    })
                    .catch((err)=> {
                        let error = err.response
                        this.showLoader = false
                        if (error.status == 400) {
                            this.errorValidate(error.data, scope)
                        } else {
                            this.$swal.fire('Failed', error.data.message, 'error')
                        }
                    })
            },
            async updateMateri(scope) {
                this.showLoader = true
                if(this.materi_form.is_file==1){
                    this.materi_form.description = '-'
                }else{
                    this.materi_form.file_type = 'text'
                    this.materi_form.file_path = '-'
                }
                let form = this.materi_form
                this.$store.dispatch('updateMateri', form)
                    .then((res) => {
                        this.showLoader = false
                        let modulId = this.modulId
                        this.$store.dispatch('getModulDetail', { modulId })
                        this.hideMateriFormModal()
                        this.$swal.fire('Success', res.message, 'success')
                    })
                    .catch((err)=> {
                        let error = err.response
                        this.showLoader = false
                        if (error.status == 400) {
                            this.errorValidate(error.data, scope)
                        } else {
                            this.$swal.fire('Failed', error.data.message, 'error')
                        }
                    })
            }
        }
    }
</script>